import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { Globals } from 'app/globals';

@Injectable({
  providedIn: 'root'
})
export class ChangeEnvironmentResolverService implements Resolve<void> {

constructor(private router: Router, private globals: Globals) { }
resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): void {
  //console.log('get in resolver')
  if(this.globals.userLoggedIn()) {
    this.router.navigate(['/']);
  }

  //console.log(JSON.parse(decodeURI(route.params['announcements'])));
  //console.log(String(decodeURI(route.params['token'])));
  //console.log(String(decodeURI(route.params['fullName'])));
  //console.log(String(decodeURI(route.params['userId'])));
  //console.log(String(decodeURI(route.params['userType'])));
  //console.log(String(decodeURI(route.params['userMode'])));
  //console.log(JSON.stringify(JSON.parse(decodeURI(route.params['modes']))));
  //console.log(String(decodeURI(route.params['email'])));
  //console.log(JSON.parse(decodeURI(route.params['canEditEmail'])));
  //console.log(String(decodeURI(route.params['NR9'])));
  //console.log(JSON.parse(decodeURI(route.params['hasBetaAccess'])));
  //console.log(String(decodeURI(route.params['environment'])));

  localStorage.setItem('tfrYcyvSqQ', JSON.parse(decodeURI(route.params['announcements'])));
  localStorage.setItem('DXZ6cN8WJS', String(decodeURI(route.params['token'])));
  localStorage.setItem('khQo9S90Ue', String(decodeURI(route.params['fullName'])));
  localStorage.setItem('OepbCPnScZ', String(decodeURI(route.params['userId'])));
  localStorage.setItem('mp1TTMDbLn', String(decodeURI(route.params['userType'])));
  localStorage.setItem('kUvPfGbd6J', String(decodeURI(route.params['userMode'])));
  localStorage.setItem('v31Ng7c6zu', JSON.stringify(JSON.parse(decodeURI(route.params['modes']))));
  localStorage.setItem('L8xxJlbW63', String(decodeURI(route.params['email'])));
  localStorage.setItem('OFYN11gft6', JSON.parse(decodeURI(route.params['canEditEmail'])));
  localStorage.setItem('ELINR9', String(decodeURI(route.params['NR9'])));
  localStorage.setItem('6zNjHUJe4f', JSON.parse(decodeURI(route.params['hasBetaAccess'])));
  localStorage.setItem('fDISWvalw6', String(decodeURI(route.params['environment'])));

  this.router.navigate(['/']);
}

}
